import styled, { css } from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
import type { MErrorMessageVariant } from './MErrorMessage.types';

interface VariantProps {
  $variant: MErrorMessageVariant;
}

export const Container = styled.div<VariantProps>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--general-spacer-02, 8px);
  width: 100%;
  background-color: var(--colors-base-20, ${baseVariables.color['base20']});
  border-radius: var(--general-spacer-02, 8px);
  padding: var(--general-spacer-03, 16px);
  box-sizing: border-box;

  ${({ $variant }) =>
    $variant === 'info'
      ? css`
          border: 1px solid var(--color-set-horizontal-vertical-rule, var(--t-horizontal-vertical-rule, #c4c4c4));
        `
      : css`
          border: 1px solid var(--colors-alert-50, ${baseVariables.color['alert50']});
        `}
`;

export const IconWrapper = styled.div<VariantProps>`
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;

  [class^='icon-'],
  [class*=' icon-'] {
    &::before {
      line-height: 1.5;
      line-height: ${({ $variant }) => ($variant === 'info' ? `1.3` : `1.5`)};
      color: ${({ $variant }) =>
        $variant === 'info'
          ? `var(--t-brand-fg-color, #1c1c1c);`
          : `var(--colors-alert-50, ${baseVariables.color['alert50']})`};
    }
  }
`;

export const TextWrapper = styled.div<VariantProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--general-spacer-01, 4px);
  flex: 1 0 0;
  min-width: 0;

  /* Override ABody styles for pixel-perfect match with Figma */
  p,
  span {
    font-family: var(--t-base-font-family, 'Swiss721 BT', sans-serif);
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5;
    color: var(--t-brand-fg-color, #1c1c1c);
    margin: 0;

    ${({ $variant }) =>
      $variant === 'info' &&
      css`
        padding: 0;
      `}
  }
`;

export const ButtonWrapper = styled.div`
  /* Override MButton tertiary styles for pixel-perfect match with Figma */
  button {
    padding: 0;
    min-height: auto;
    font-family: var(--t-base-font-family, 'Swiss721 BT', sans-serif);
    span {
      font-weight: 700;
    }
    font-size: 0.8125rem;
    font-weight: 700;
    line-height: 1;
    color: var(--t-brand-fg-color, #1c1c1c);
    gap: var(--general-spacer-01, 4px);
    [class^='icon-'],
    [class*=' icon-'] {
      font-size: 0.8125rem;
      font-weight: 700;
      &::before {
        color: inherit;
      }
    }
  }
`;
